module.exports = __webpack_public_path__ + "static/img/icon_partner.781c370.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_partner.png
// module id = 3n7z
// module chunks = 1